import { addPlanViewed } from './statistics';

const scrollTop = () => {
  window.scrollTo(0, 0);
};

const customSliderSettings = (plans) => ({
  infinite: false,
  centerMode: true,
  centerPadding: '15px',
  onInit: () => {
    console.log('init');
    addPlanViewed(plans[0].id);
  },
  beforeChange: (oldIndex, newIndex) => {
    if (oldIndex !== newIndex) {
      addPlanViewed(plans[newIndex].id);
    }
  }
});

export { scrollTop, customSliderSettings };
